import { render, staticRenderFns } from "./LivingItem.vue?vue&type=template&id=79a28277&scoped=true&"
import script from "./LivingItem.vue?vue&type=script&lang=js&"
export * from "./LivingItem.vue?vue&type=script&lang=js&"
import style0 from "./LivingItem.vue?vue&type=style&index=0&id=79a28277&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a28277",
  null
  
)

export default component.exports